<template>
  <div>
    <div>
      <Base--InlineTextBlock>
        Сумма ставок: {{ stats.bets_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Сумма выигрыша: {{ stats.prizes_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Прибыль: {{ stats.profit }}
      </Base--InlineTextBlock>
    </div>
    <FruttoStatisticsTable />
    <BaseSideButtons back />
  </div>
</template>

<script>
import BaseSideButtons from '../Base--SideButtons'
import { getGeneralStatistics } from '../../../api/frutto'
import FruttoStatisticsTable from '../common/Table/FruttoStatisticsTable/FruttoStatisticsTable'

export default {
  name: 'Frutto',
  components: { BaseSideButtons, FruttoStatisticsTable },
  data () {
    return {
      stats: {
        bets_sum: 0,
        prizes_sum: 0,
        profit: 0
      }
    }
  },
  mounted () {
    getGeneralStatistics().then(res => {
      this.stats = res.data
    })
  }
}
</script>

<style scoped>

</style>
